if($('header#header').length){
    if($('.top-navigation-tools a.top-nav-button-account.secondary').length){
        $('header#header .navigation-buttons, .responsive-tools').prepend('<a href="/moje-garaz/" class="favorite"></a>');
    }
    else{
        $('header#header .navigation-buttons, .responsive-tools').prepend('<a href="/registrace/" class="favorite"></a>');
    }
    $('.navigation-buttons a[data-target="cart"]').clone().appendTo('.responsive-tools')
    $('.top-navigation-tools .dropdown').clone().appendTo('.responsive-tools')
    $('.header-top').append($('.top-navigation-bar .responsive-tools'))
    $('#customerLogin input[name="email"]').attr('placeholder', '').before('<label for="email">Uživatelské jméno nebo e-mail<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', '').before('<label for="password">Heslo<span>*</span></label>')  
    $('<span class="close"></span>').appendTo('.popup-widget-inner');
    $('nav#navigation .menu-image img').each(function(){
        if($(this).attr('data-src')){
            $(this).attr('data-src', $(this).attr('data-src').replace('thumb', 'orig'))
            $(this).attr('src', $(this).attr('data-src'))
        }
       
    })
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    }) 
    $(document).on('click', function (event) {
        var clickedElement = $(event.target);
        if (!(clickedElement.closest('.login-widget').length || clickedElement.is('a[data-target="login"]'))) {
            $('body').removeClass('login-window-visible user-action-visible');
        }
    });   
}